import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PAYMENT_ID_LOADING = 'GET_PAYMENT_ID_LOADING';
export const GET_PAYMENT_ID_SUCCESS = 'GET_PAYMENT_ID_SUCCESS';
export const GET_PAYMENT_ID_REJECT = 'GET_PAYMENT_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getPaymentIdLoading = () => ({ type: GET_PAYMENT_ID_LOADING });
export const getPaymentIdSuccess = (payload) => ({ type: GET_PAYMENT_ID_SUCCESS, payload });
export const getPaymentIdReject = (payload) => ({ type: GET_PAYMENT_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getPaymentIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/TypePayments/${id}`, options);
};